const Image = ({ src = '' }) => {
  return (
    <img
      alt={`gallery`}
      className="block h-full w-full rounded-lg object-cover object-center"
      src={src}
    />
  );
};

export default Image;
